import { MasterPreset } from "./masterPresets";
import { progressions } from "./chordUtils";
import { SequencerProgressionState } from "../components/sequencer/types";

export const resolvePresetProgressionState = (
  preset?: MasterPreset
): SequencerProgressionState | null => {
  if (!preset) {
    return null;
  }

  const savedRoman = preset.chord.roman ?? preset.chord.customRoman;
  const savedMode = preset.chord.mode ?? preset.chord.customMode;
  if (savedRoman && savedRoman.length > 0 && savedMode) {
    return {
      name: preset.chord.progression,
      roman: [...savedRoman],
      mode: savedMode,
    };
  }

  const builtIn =
    progressions[preset.chord.progression as keyof typeof progressions];
  if (!builtIn) {
    return null;
  }

  return {
    name: preset.chord.progression,
    roman: [...builtIn.roman],
    mode: builtIn.mode,
  };
};

export const hasProgressionChanged = (
  presetState: SequencerProgressionState | null,
  currentState: SequencerProgressionState | null
): boolean => {
  if (!presetState || !currentState) {
    return false;
  }

  if (presetState.mode !== currentState.mode) {
    return true;
  }

  if (presetState.roman.length !== currentState.roman.length) {
    return true;
  }

  return presetState.roman.some(
    (chord, index) => chord !== currentState.roman[index]
  );
};
